import { startWatch, lazyLoad } from 'Utils/lazy-load'

startWatch([...document.querySelectorAll('[data-lazy]')], (elem, isVisible) => {
    if (isVisible)
        lazyLoad(elem)
}, "20% 0% 20%")